<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size: 15px; font-weight: bold"
          >Consignee payments</small
        >
      </legend>
      <form @submit.prevent="newPayment()">
        <div class="row">
          <input
            type="hidden"
            class="consignee_id"
            :value="Trip.consignee_id"
          />
          <input type="hidden" class="trip_id" :value="Trip.id" />
          <div class="col-md-3">
            <label>Consignee name</label>
            <input
              type="text"
              class="form-control consignee_name"
              :value="Trip.consignee_name"
              readonly
            />
          </div>
          <div class="col-md-3">
            <label>Truck number</label>
            <input
              type="text"
              class="form-control truck_no"
              :value="Trip.truck_no"
              readonly
            />
          </div>
          <div class="col-md-3">
            <label>Container no</label>
            <input
              type="text"
              class="form-control container_no"
              :value="Trip.container_no"
              readonly
            />
          </div>
          <div class="col-md-3">
            <label>Grnad total ($)</label>
            <input
              type="text"
              class="form-control grand_total"
              :value="Trip.grand_total"
              readonly
            />
          </div>
        </div>
        <div></div>
        <p></p>
        <div class="row">
          <div class="col-md-4">
            <label>Payment date</label>
            <input type="date" class="form-control payment_date" required />
          </div>
          <div class="col-md-4">
            <label>Mode of payment</label>
            <select
              name="mode_payment"
              class="form-control mode_payment"
              required
            >
              <option value>select mode of payment</option>
              <option value="Bank">Bank</option>
              <option value="Cash">Cash</option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Amount paid ($)</label>
            <input
              type="number"
              class="form-control amount_paid"
              placeholder="amount paid"
              required
            />
          </div>
        </div>
        <p></p>
        <button type="submit" class="btn btn-primary btn-flat creatingPayment">
          <i class="fa fa-money"></i> add payment
        </button>
        <button
          type="button"
          class="btn btn-info btn-flat creatingPaymentLoader"
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i> please
          wait...
        </button>
      </form>
    </fieldset>
    <div>
      <fieldset class="border p-3">
        <legend class="auto-wp">
          <small style="font-size: 15px; font-weight: bold"
            >Consignee payments</small
          >
        </legend>
        <div></div>
        <div>
          <vue-good-table
            :columns="columns"
            :rows="systemPayments"
            :fixed-header="true"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 6,
              position: 'bottom',
              perPageDropdown: [3, 7, 9],
              dropdownAllowAll: false,
              setCurrentPage: 1,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'Rows per page',
              ofLabel: 'of',
              pageLabel: 'page', // for 'pages' mode
              allLabel: 'All',
            }"
          >
          </vue-good-table>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import $ from "jquery";
export default {
  data() {
    return {
      columns: [
        {
          label: "Payment date",
          field: "payment_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th
        },
        {
          label: "Mode of Payment",
          field: "mode_payment",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, //
        },
        {
          label: "Amount paid",
          field: "amount_paid",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, //
        },
        {
          label: "Balance",
          field: "balance_remaining",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, //
        },
      ],
    };
  },
  created() {
    if (this.$store.getters.Trip.length === 0) {
      router.push("/managetrips");
    }
  },
  computed: {
    ...mapGetters(["Trip", "systemPayments"]),
  },
  methods: {
    ...mapActions(["newPayment"]),
  },
};
</script>
<style scoped>
.creatingPaymentLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/payments/payments.vue